import { defineAction } from '~/prix'
import { z } from 'zod'
import creditDocumentDeleteAction from './creditDocumentDelete.action.json' with { type: 'json' }
import { creditDocumentObject } from '../creditDocumentObject'

const creditDocumentDeleteDefinition = defineAction({
  ...creditDocumentDeleteAction,

  input: z.object({ id: creditDocumentObject.shape.id }),
  output: z.object({}),
})

export default creditDocumentDeleteDefinition

